import { render, staticRenderFns } from "./MandatsAnnulation.vue?vue&type=template&id=1a18c504&"
import script from "./MandatsAnnulation.vue?vue&type=script&lang=js&"
export * from "./MandatsAnnulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports